import React from "react";
import PropTypes from "prop-types";
import Search from "./Search";
import Range from "./Range";
import Checkboxes from "./Checkboxes";
import { INVENTORY } from "../../../constants/config/parameters";
import PartsFilter from "./PartsFilter";
import "./style.css";
import MediaQuery from "react-responsive";
import breakpoints from "../../../constants/breakpoints";

/**
 * @name Filters
 * @function
 * @description Displays Filters for each column
 * @returns {JSX}
 * @param {*} props
 */
const Filters = ({
  label,
  value,
  defaultPlaceholder,
  className,
  verticalScrollClass,
}) => {
  const renderFilterComponent = (filter) => {
    const params = {
      ...filter,
      parameter: filter.id,
      key: `parameter-${filter.id}`,
    };
    if (filter.id === INVENTORY) {
      return <th key={filter.id}></th>;
    } else {
      switch (filter.format) {
        case "checkbox":
          return (
            <th
              className="filter-checkbox"
              key={filter.id}
              data-parameter={filter.id}
            >
              <Checkboxes options={filter.options} label={label} {...params} />
            </th>
          );
        case "range":
          return (
            <th
              className="filter-range"
              key={filter.id}
              role="cell"
              data-parameter={filter.id}
            >
              <Range value={filter.uom} {...params} />
            </th>
          );
        case "text":
          return (
            <th
              className="filter-text"
              key={filter.id}
              data-parameter={filter.id}
            >
              <Search
                name={params.value}
                defaultPlaceholder={defaultPlaceholder}
                label={filter.name}
                {...params}
              />
            </th>
          );
        default:
          return null;
      }
    }
  };

  return (
    <tr role="row" className={`filters ${verticalScrollClass}`}>
      <MediaQuery minDeviceWidth={breakpoints.tablet.max + 1}>
        <th></th>
      </MediaQuery>
      <th className={`parts-search ${className}`}>
        <PartsFilter
          defaultPlaceholder={defaultPlaceholder}
          label={label.parts}
        />
      </th>
      {value.map((filter) => renderFilterComponent(filter))}
    </tr>
  );
};

Filters.propTypes = {
  label: PropTypes.object.isRequired,
  value: PropTypes.array.isRequired,
  defaultPlaceholder: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  verticalScrollClass: PropTypes.string.isRequired,
};

export default Filters;
